import { render, staticRenderFns } from "./active-sign-notes.vue?vue&type=template&id=0d53e4a2&"
import script from "./active-sign-notes.vue?vue&type=script&lang=js&"
export * from "./active-sign-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports